export default __webpack_public_path__ + "assets/images/button-burger.3fb5c68987803528fd449dda8fa5daa3.svg";